<div class="get-labels-details-toggle">
  <button
    type="button"
    class="get-labels-details-toggle__link"
    data-testid="get-labels-view-details"
    [attr.aria-expanded]="expanded()"
    (click)="onToggle()"
  >
    <puro-typography component="span" variant="body1">
      {{ 'createShipment.getLabels.viewShipmentDetails' | translate }}
    </puro-typography>
    <puro-icon
      class="get-labels-details-toggle__chevron"
      [class.get-labels-details-toggle__chevron--collapsed]="!expanded()"
      name="open-chevron-up-arrow"
      size="sm"
      aria-hidden="true"
    />
  </button>

  <div
    class="get-labels-details-toggle__panel"
    [class.get-labels-details-toggle__panel--hidden]="!expanded()"
  >
    <ng-content />
  </div>

  <div class="get-labels-details-toggle__download">
    <puro-button
      type="button"
      variant="secondary"
      size="medium"
      [icon]="true"
      [loading]="downloadProcessing()"
      [disabled]="downloadProcessing()"
      [attr.aria-describedby]="downloadFailed() ? failureStatusId : null"
      data-testid="get-labels-download-details"
      (buttonClick)="onDownloadDetails()"
    >
      <img
        icon
        class="get-labels-details-toggle__print-icon"
        src="assets/icons/print-secondary.svg"
        alt=""
        aria-hidden="true"
      />
      {{ 'createShipment.getLabels.printShipmentDetails' | translate }}
    </puro-button>
    @if (downloadFailed()) {
      <output
        class="get-labels-details-toggle__failure"
        data-testid="get-labels-shipment-details-failed"
        [attr.id]="failureStatusId"
      >
        <puro-typography component="p" variant="caption">
          <strong>{{ 'createShipment.getLabels.shipmentDetailsFailed' | translate }}</strong>
        </puro-typography>
        <puro-typography component="p" variant="caption">
          {{ 'createShipment.getLabels.retryLabel' | translate }}
        </puro-typography>
      </output>
    }
  </div>
</div>
